<template>
  <el-dialog
    title="提示"
    append-to-body
    :visible.sync="visible"
    width="631px"
    :lock-scroll="false"
    destroy-on-close
    @close="onclose"
  >
    <div style="width: 100%; height: 646px">
      <div class="dialogHeader">
        <div class="dialogHeader__title">{{ $t("bigScreen.报警统计") }}</div>
        <i class="el-icon-close" @click="visible = false"></i>
      </div>
      <el-date-picker
        class="m-picker"
        :clearable="false"
        v-model="daterange"
        type="daterange"
        @change="timeChange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <base-loading :loading="loadingBarBattery" background="transparent">
        <echarts-bar-battery
          v-if="bjXData.length > 0"
          style="margin-top: 10px"
          :yData="bjYData"
          :data="bjXData"
          height="500px"
          width="100%"
        ></echarts-bar-battery>
        <base-empty style="margin-top: -15%" v-else></base-empty>
      </base-loading>
    </div>
  </el-dialog>
</template>

<script>
import EchartsBarBattery from "@/components/echarts-bar-battery/index.vue";
import { getBjjltj } from "@/api/dpIndex";

export default {
  name: "bjtj-dialog",
  components: { EchartsBarBattery },
  props: {
    showDialog: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
      loadingBarBattery: false,
      daterange: [],
      bjXData: [],
      bjYData: [],
    };
  },
  watch: {
    showDialog() {
      this.visible = this.showDialog;
    },
  },
  created() {
    this.visible = this.showDialog;
    this.init();
  },
  methods: {
    init() {
      this.getNowMonth();
      this.getBjjltj();
    },
    getNowMonth() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let monthFirstday = year + "-" + month + "-1";
      let nowDate = year + "-" + month + "-" + day;
      this.daterange = [monthFirstday, nowDate];
    },
    timeChange() {
      this.getBjjltj();
    },
    async getBjjltj() {
      this.loadingBarBattery = true;
      this.bjXData = [];
      this.bjYData = [];
      let params = {
        token: this.$store.state.user.token,
        startDate: this.daterange ? this.daterange[0] : "",
        endDate: this.daterange ? this.daterange[1] : "",
      };
      getBjjltj(params).then((result) => {
        result.rows.forEach((item) => {
          this.bjXData.push(item.sl);
          this.bjYData.push(item.bjlxmc);
        });
        this.loadingBarBattery = false;
      });
    },
    onclose() {
      this.bjXData = [];
      this.bjYData = [];
      this.daterange = [];
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  background: #010d37;
  box-shadow: inset 0px 0px 22px 0px rgba(104, 232, 255, 0.7);
  border: 2px solid rgba(104, 232, 255, 0.3);
}
/deep/.el-dialog__header {
  display: none;
}
.dialogHeader {
  width: 100%;
  min-height: 40px;
  background: url("../../assets/images/headersmall.png");
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 28px;
  &__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 22px;
    color: #68e8ff;
    line-height: 22px;
  }
  i {
    font-size: 12px;
    color: #37ccfd;
    cursor: pointer;
  }
}
.m-picker {
  margin-top: 28px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #68e8ff;
  background-color: transparent;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  border: 0.7px solid #3e8ca6 !important;
  z-index: 9999;
  //文本域占位字符颜色更改
  ::-webkit-input-placeholder {
    color: #68e8ff !important;
  }
  /deep/ .el-input__icon {
    color: #68e8ff !important;
  }
  /deep/ .el-range-input {
    background-color: transparent;
    color: #68e8ff !important;
  }
  /* 修改Element UI中日期选择器placeholder的颜色 */
  /deep/ .el-date-editor .el-input__placeholder {
    color: #68e8ff !important;
  }
  /deep/ .el-range-separator {
    color: #68e8ff !important;
  }
}
</style>
